<template>
    <div class="result">
        <DecisionSummary :answers="answers" :summary-from-result="data.summary" />
        <div
            v-if="data.situation && data.situation.length"
            class="result-section"
        >
            <h3 class="result-title">{{ t('situation') }}</h3>
            <ul class="no-bullet result-list">
                <li v-for="(item, i) in data.situation" :key="i" v-html="item"></li>
            </ul>
        </div>
        <div
            v-if="data.procedure && data.procedure.length"
            class="result-section"
        >
            <h3 class="result-title">{{ t('procedure') }}</h3>
            <ul class="no-bullet result-list">
                <li v-for="(item, i) in data.procedure" :key="i" v-html="item"></li>
            </ul>
        </div>
        <div
            v-if="data.documents && data.documents.length"
            class="result-section"
        >
            <h3 class="result-title">{{ t('documents') }}</h3>
            <ul class="result-list">
                <li v-for="(item, i) in data.documents" :key="i" v-html="item"></li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import DecisionSummary from '@/best-fare-students/components/DecisionSummary';

defineProps({
    data: {
        type: Object,
        default() {
            return {};
        },
    },
    answers: {
        type: Array,
        default() {
            return [];
        },
    },
});

const { t } = useI18n({
    messages: {
        fr: {
            situation: 'Votre situation',
            procedure: 'Procédure à suivre',
            documents: 'Documents requis',
        },
        en: {
            situation: 'Your situation',
            procedure: 'Procedure to follow',
            documents: 'Required documents',
        },
    },
});
</script>

<style lang="scss" scoped>
.result-section {
    display: flex;
    flex-direction: column;
    gap: 8px 16px;
    padding: 16px;
    border-bottom: 2px solid $color-black-2;
    @include breakpoint(medium) {
        padding: 24px;
        align-items: flex-start;
        flex-direction: row;
    }
    &:last-child {
        border: none;
    }
}
.result-title {
    @include rem-typo(18px);
    margin-bottom: 8px;
    @include breakpoint(medium) {
        width: 25%;
        flex-shrink: 0;
    }
}
.result-list {
    flex-grow: 1;
    margin-top: 0;
    :deep(.button) {
        margin-top: 16px;
        strong {
            font-weight: 600;
        }
    }
}
</style>
